export const SIDEBAR_EXPERIENCE_NAME = 'conditional-formatting';
export const CONDITIONAL_FORMATTING_EXPERIENCE = 'conditionalFormattingSidebarOpen';
